import React from "react";
import { Switch, Redirect, useLocation, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import RocketIcon from "@material-ui/icons/CodeOutlined";
import KeyIcon from "@material-ui/icons/VpnKeyOutlined";
import WebhooksIcon from "@material-ui/icons/SyncAltOutlined";
import LogsIcon from "@material-ui/icons/SubjectOutlined";
import UsageIcon from "@material-ui/icons/ReceiptOutlined";
import DocsIcon from "@material-ui/icons/MenuBookOutlined";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import Route from "../../routes/Route";
import Overview from "./Overview";
import ApiLogs from "./ApiLogs";
import Secrets from "../Secrets";
import Webhooks from "../Webhooks";
import Usage from "../Usage";

const useStyles = makeStyles(theme => ({
  root: { display: "flex", height: "100%", minHeight: 0, background: theme.app.chatBg },
  nav: {
    width: 224,
    flexShrink: 0,
    background: "#fff",
    borderRight: `1px solid ${theme.app.border}`,
    padding: "16px 12px",
    overflowY: "auto",
  },
  navTitle: {
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: theme.app.textTertiary,
    fontWeight: 700,
    padding: "0 8px 8px",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    height: 36,
    padding: "0 10px",
    borderRadius: 8,
    color: theme.app.textSecondary,
    fontSize: 13.5,
    cursor: "pointer",
    marginBottom: 2,
    "& svg": { fontSize: 18, color: theme.app.textTertiary },
    "&:hover": { background: theme.app.hover, color: theme.app.ink },
  },
  itemOn: {
    background: "#F0F2F5",
    color: theme.app.ink,
    fontWeight: 600,
    boxShadow: `inset 2.5px 0 0 0 ${theme.app.green}`,
    "& svg": { color: theme.app.ink },
    "&:hover": { background: "#F0F2F5", color: theme.app.ink },
  },
  ext: { marginLeft: "auto", fontSize: 14, opacity: 0.6 },
  sep: { height: 1, background: theme.app.lineSoft, margin: "10px 6px" },
  content: { flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" },
}));

const NAV = [
  { key: "overview", path: "/developers/overview", label: "Visão geral", icon: <RocketIcon /> },
  { key: "keys", path: "/developers/keys", label: "Chaves de API", icon: <KeyIcon /> },
  { key: "webhooks", path: "/developers/webhooks", label: "Webhooks", icon: <WebhooksIcon /> },
  { key: "logs", path: "/developers/api-logs", label: "Logs da API", icon: <LogsIcon /> },
  { key: "usage", path: "/developers/usage", label: "Uso & Saldo", icon: <UsageIcon /> },
];

const Developers = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const isOn = path => location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <div className={classes.root}>
      <nav className={classes.nav}>
        <div className={classes.navTitle}>Desenvolvedores</div>
        {NAV.map(it => (
          <div
            key={it.key}
            className={`${classes.item} ${isOn(it.path) ? classes.itemOn : ""}`}
            onClick={() => history.push(it.path)}
          >
            {it.icon}
            <span>{it.label}</span>
          </div>
        ))}
        <div className={classes.sep} />
        <a className={classes.item} href="/docs" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
          <DocsIcon />
          <span>Documentação</span>
          <OpenInNewIcon className={classes.ext} />
        </a>
      </nav>

      <div className={classes.content}>
        <Switch>
          <Route exact path="/developers/overview" component={Overview} isPrivate />
          <Route exact path="/developers/keys" component={Secrets} isPrivate />
          <Route exact path="/developers/webhooks" component={Webhooks} isPrivate />
          <Route exact path="/developers/api-logs" component={ApiLogs} isPrivate />
          {/* Eventos foi movido para o grupo "Construtor" (/events) — compat */}
          <Redirect exact from="/developers/events" to="/events" />
          <Route exact path="/developers/usage" component={Usage} isPrivate />
          <Redirect to="/developers/overview" />
        </Switch>
      </div>
    </div>
  );
};

export default Developers;
